import Vue from 'vue'
import VueRouter from 'vue-router'
import { routeIreg } from './routeIreg'
import { routeSavitarna } from './routeSavitarna'
import { routePublic } from './routePublic'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import store from '@/store'
import { authRoute } from './routeRole'
store.dispatch('setAppHost', {host:window.location.host, pathname: window.location.pathname} )
const appSavitarna = store.getters.appSavitarna
const appPublic = store.getters.appPublic
const routes = appSavitarna ? routeSavitarna : (!appSavitarna && appPublic ? routePublic : routeIreg)

Vue.use(VueRouter)

Vue.use(VueRouter)
const router = new VueRouter({
  base: '/',
  mode: 'history',
  linkActiveClass: 'active',
  routes: routes,
})
// router gards
if (appSavitarna) {
  router.beforeEach((to, from, next) => {
    // if (to.name == 'procurationSteps') {
    //   let userCompany = store.getters.getUserCompany
    //   if (userCompany == null || userCompany == undefined) {
    //     next({
    //       name: 'savInfoPage',
    //       params: {
    //         type: 'serviceUnavailable',
    //       },
    //     })
    //   }
    // }
    NProgress.start()
    // if (to.query.enc) {
    //   next()
    // } else {
    //   if (from.query.enc) {
    //     to.query.xid = from.query.xid
    //     to.query.enc = from.query.enc
    //     next(to)
    //   } else {
    //     next()
    //   }
    // }

    if (to.query.xid) {
      next()
    } else {
      if (from.query.xid) {
        to.query.xid = from.query.xid
        next(to)
      } else {
        next()
      }
    }
  })
}

if (!appSavitarna && appPublic) {
  router.beforeEach((to, from, next) => {
    NProgress.start()
    next()
  })
}

if (!appSavitarna && !appPublic) {
  router.beforeEach((to, from, next) => {
    NProgress.start()
    const token = store.getters.getAccessToken

    if (to.meta.open) {
      next()
      return
    }
    if (!token) {
      next({ name: 'login' })
      return
    }
    if (!authRoute(to.name)) {
      next({ name: 'home' })
      return
    }

    next()
  })
}

router.afterEach(() => {
  NProgress.done()
})

const { isNavigationFailure, NavigationFailureType } = VueRouter
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => {
    NProgress.done()
    if (
      !isNavigationFailure(err, NavigationFailureType.aborted) &&
      !isNavigationFailure(err, NavigationFailureType.canceled) &&
      !isNavigationFailure(err, NavigationFailureType.duplicated)
    )
      throw err
  })
}

export default router
